import { Link } from "react-router-dom";
import { History, X } from "lucide-react";
import { useState } from "react";
import { thumbUrl, retryImg } from "@/lib/api";

const KEY = "awg_recent_designs";
const MAX = 6;

export const readRecent = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };

export const rememberDesign = (d) => {
  if (!d?.design_id) return;
  const item = { design_id: d.design_id, title: d.title, image_url: d.image_url, base_price: d.base_price, at: Date.now() };
  const next = [item, ...readRecent().filter((r) => r.design_id !== d.design_id)].slice(0, MAX);
  localStorage.setItem(KEY, JSON.stringify(next));
};

export const RecentlyViewed = () => {
  const [items, setItems] = useState(readRecent);
  if (!items.length) return null;
  const clear = () => { localStorage.removeItem(KEY); setItems([]); };
  return (
    <div className="mt-8" data-testid="recently-viewed">
      <div className="flex items-center justify-between mb-3">
        <p className="text-xs font-mono-p uppercase tracking-wider text-zinc-500 flex items-center gap-1.5"><History size={12} className="text-[#22c3d6]" />Recently viewed</p>
        <button onClick={clear} data-testid="recently-viewed-clear" className="text-xs font-mono-p text-zinc-500 hover:text-white inline-flex items-center gap-1"><X size={12} />Clear</button>
      </div>
      <div className="flex gap-3 overflow-x-auto pb-2 -mx-1 px-1 snap-x">
        {items.map((d) => (
          <Link key={d.design_id} to={`/catalog/${d.design_id}`} data-testid={`recent-${d.design_id}`} className="group snap-start shrink-0 w-32 sm:w-36 rounded-xl border border-zinc-800 bg-[#12141a] hover:border-[#22c3d6] transition-colors overflow-hidden">
            <div className="checker aspect-square flex items-center justify-center p-2 img-tile" data-img-tile>
              <img src={thumbUrl(d.image_url, 240)} alt={d.title || "Design"} loading="lazy" onError={retryImg} onLoad={(e) => e.currentTarget.closest("[data-img-tile]")?.setAttribute("data-img-loaded", "1")} className="max-w-full max-h-full object-contain group-hover:scale-105 transition-transform img-tile-img" />
              <div className="img-tile-skeleton" aria-hidden="true" />
            </div>
            <p className="text-xs text-zinc-300 px-2 py-1.5 truncate">{d.title}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};
